import { render, staticRenderFns } from "./Drives.vue?vue&type=template&id=183e7a12"
import script from "./Drives.vue?vue&type=script&lang=js"
export * from "./Drives.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports